import { ref } from "vue";

export function useDrag(positions, editMode, dragAllMode) {
    const draggingKey = ref(null);
    const offset = ref({ x: 0, y: 0 });

    // Used by Drag All mode
    const lastPointer = ref({ x: 0, y: 0 });

    const isDragging = ref(false);
    const activeField = ref(null);

    const getPointer = (event) => {
        return event.type.startsWith("touch")
            ? event.touches[0]
            : event;
    };

    const getCanvasRect = () => {
        return document
            .getElementById("printable")
            ?.getBoundingClientRect();
    };

    const startDrag = (event, key) => {
        if (!editMode.value) return;

        const e = getPointer(event);
        const rect = getCanvasRect();

        if (!rect) return;

        // Make sure the field exists
        if (!positions.value[key]) return;

        draggingKey.value = key;
        activeField.value = key;
        isDragging.value = true;

        /*
         * DRAG ALL MODE
         *
         * We don't care about the field's individual
         * offset here. We only need the starting pointer
         * position so we can calculate movement delta.
         */
        if (dragAllMode.value) {
            lastPointer.value = {
                x: e.clientX,
                y: e.clientY,
            };

            return;
        }

        /*
         * NORMAL SINGLE-FIELD DRAG
         *
         * Preserve the existing behavior.
         */
        offset.value = {
            x:
                e.clientX -
                rect.left -
                positions.value[key].x,

            y:
                e.clientY -
                rect.top -
                positions.value[key].y,
        };
    };

    const onDrag = (event) => {
        if (!draggingKey.value) return;

        const e = getPointer(event);
        const rect = getCanvasRect();

        if (!rect) return;

        /*
         * ========================================================
         * DRAG ALL
         * ========================================================
         *
         * Calculate how far the pointer moved since the
         * previous event, then apply that same movement
         * to every field.
         */
        if (dragAllMode.value) {
            const deltaX =
                e.clientX - lastPointer.value.x;

            const deltaY =
                e.clientY - lastPointer.value.y;

            if (deltaX === 0 && deltaY === 0) {
                return;
            }

            Object.values(positions.value).forEach(
                (position) => {
                    position.x += deltaX;
                    position.y += deltaY;
                }
            );

            lastPointer.value = {
                x: e.clientX,
                y: e.clientY,
            };

            return;
        }

        /*
         * ========================================================
         * NORMAL SINGLE-FIELD DRAG
         * ========================================================
         */
        const position =
            positions.value[draggingKey.value];

        if (!position) return;

        position.x =
            e.clientX -
            rect.left -
            offset.value.x;

        position.y =
            e.clientY -
            rect.top -
            offset.value.y;
    };

    const stopDrag = () => {
        draggingKey.value = null;
        activeField.value = null;
        isDragging.value = false;
    };

    return {
        startDrag,
        onDrag,
        stopDrag,
        isDragging,
        activeField,
    };
}